<template>
	<footer class="main-footer">
		<div class="container">
			<div class="row">
				<div class="col-24 col-md-12 footer-column">
					<h3>Links</h3>
					<ul class="footer-links">
						<li><router-link to="/about">About Pixelcore Development</router-link></li>
						<li><router-link to="/contact">Contact</router-link></li>
						<li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
						<li><router-link to="/terms-and-conditions">Terms & Conditions</router-link></li>
					</ul>
				</div>
				<div class="col-24 col-md-12 footer-column">
					<h3>Join The Newsletter</h3>
					<p>Sign up for news, articles and promotions from Pixelcore Development!</p>
					<newsletter-form></newsletter-form>
				</div>
			</div>
		</div>
		<div class="copyright">
			<div class="left">&copy;{{ (new Date()).getFullYear() }} Pixelcore Development. All Rights Reserved.</div>
			<div class="right">Custom Software, Limitless Possibilities</div>
		</div>
	</footer>
</template>

<script>
	export default {

	}
</script>